// User
export const apiInsertUser = "User/Insert"
export const apiDeleteUser = "User/Delete"
export const apiDetailUser = "User/GetDetail"
export const apiUpdateUser = "User/Update"
export const apiGetListUser = "User/GetList"
export const apiGetListRepresentative = "User/GetListRepresentative"
export const apiInsertRepresentative = "User/InsertRepresentative"
export const apiAddUserRepresentative = "User/AddUserRepresentative"
export const apiUpdateRepresentative = "User/UpdateRepresentative"
export const apiCountListUser = "User/CountListUser"

export const apiImportUser = "User/ImportUser"
export const apiExportUser = "User/ExportUser"
export const apiChangeStatus = "User/ChangeStatus"
export const apiGetTemplateFileImportUser = "User/GetTemplateFileImportUser"
export const apiGetListGuest = "User/GetListGuest"
export const apiGetAccount = "User/GetAccount"
export const apiExportGuest = "User/ExportGuest"
export const apiImportGuest = "User/ImportGuest"
export const apiGetTemplateFileImportGuest = "User/GetTemplateFileImportGuest"
export const apiUpdateAccount = "User/UpdateAccount"
export const apiReplacePassword = "User/ReplacePassword"
export const apiGetInforUser = "User/GetInforUser"
export const apiChangeInfor = "User/ChangeInfor"
export const apiChangeInforOrgan = "User/ChangeInforOrgan"
export const apiChangeImgUser = "User/ChangeImgUser"
export const apiInsertRecruiter = "User/InsertRecruiter"
export const apiGetListUserInDept = "User/GetListUserInDept"
export const apiGetListRecruterByUserID = "User/GetListRecruterByUserID"
export const apiCheckTokenUSB = "User/CheckTokenUSB"
export const apiGetInfoUserRepresentative = "User/GetinforUserRepresentative"

export const apiGetAllAccountUser = "User/GetAllAccountUser"
export const apiInsertAccountUser = "User/InsertAccountUser"
export const apiUpdateAccountUser = "User/UpdateAccountUser"
export const apiDeletaAccountUser = "User/DeleteAccountUser"
export const apiGetAllUserDirectory = "User/GetAllUserDirectory"
export const apiInsertGuest = "User/InsertGuest"
export const apiGetListRepresentativeByType = "User/GetListRepresentativeByType"
export const apiChangeInforTemp = "User/ChangeInforTemp"
export const apiChangeInforOrganTemp = "User/ChangeInforOrganTemp"
export const apiGetListUpdateRequest = "User/GetListUpdateRequest"
export const apiGetDetailChange = "User/GetDetailChange"
export const apiConfirmChange = "User/ConfirmChange"
export const apiRejectChange = "User/RejectChange"

export const apiGetDetailGuest = "User/GetDetailGuest"
export const apiBroadcastMessage = "User/BroadcastMessage"
export const apiGetUserByID = "User/GetUserByID"
export const apiGetListSigner = "User/GetListSigner"
